/* This file is autogenerated, see readme.md for instructions */
import CheckCircleSvgIcon from '@bloomreach/banana-theme/icons/check-circle.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const CheckCircleIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <CheckCircleSvgIcon />
    </Icon>
  );
});

CheckCircleIcon.displayName = 'CheckCircleIcon';

export default CheckCircleIcon;
